<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="32" height="32" rx="16" fill="#2A3243"/>
<path d="M25 16H7" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16 7V25" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
